// extracted by mini-css-extract-plugin
var _1 = "IdwellToIdwellRequestWizardFormModal-moduledisabledPointerEvents__P4VWx";
export { _1 as "disabledPointerEvents" }
